var cov_42aiq0o6b = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/Input.tsx",
      hash = "b48d2725d896bca354292c101188b632cedfd6dc",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/Input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 20
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 21
        }
      },
      "2": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 16
        }
      },
      "3": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "4": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 50
        }
      },
      "5": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 50
        }
      },
      "6": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 50
        }
      },
      "7": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 48
        }
      },
      "8": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 25
        }
      },
      "9": {
        start: {
          line: 47,
          column: 21
        },
        end: {
          line: 47,
          column: 31
        }
      },
      "10": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 80
        }
      },
      "11": {
        start: {
          line: 48,
          column: 71
        },
        end: {
          line: 48,
          column: 80
        }
      },
      "12": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 60
        }
      },
      "13": {
        start: {
          line: 53,
          column: 50
        },
        end: {
          line: 53,
          column: 60
        }
      },
      "14": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 58,
          column: 5
        }
      },
      "15": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 57,
          column: 7
        }
      },
      "16": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 39
        }
      },
      "17": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 52
        }
      },
      "18": {
        start: {
          line: 59,
          column: 24
        },
        end: {
          line: 59,
          column: 52
        }
      },
      "19": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "20": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 66,
          column: 8
        }
      },
      "21": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 12
        }
      },
      "22": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "23": {
        start: {
          line: 73,
          column: 12
        },
        end: {
          line: 73,
          column: 24
        }
      },
      "24": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 80,
          column: 6
        }
      },
      "25": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 40
        }
      },
      "26": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 25
        }
      },
      "27": {
        start: {
          line: 88,
          column: 17
        },
        end: {
          line: 88,
          column: 57
        }
      },
      "28": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 56
        }
      },
      "29": {
        start: {
          line: 90,
          column: 14
        },
        end: {
          line: 90,
          column: 42
        }
      },
      "30": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 26
        }
      },
      "31": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 23
        }
      },
      "32": {
        start: {
          line: 100,
          column: 22
        },
        end: {
          line: 100,
          column: 32
        }
      },
      "33": {
        start: {
          line: 101,
          column: 18
        },
        end: {
          line: 109,
          column: 5
        }
      },
      "34": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 20
          },
          end: {
            line: 5,
            column: 21
          }
        },
        loc: {
          start: {
            line: 5,
            column: 39
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 28
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 22
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 42
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        loc: {
          start: {
            line: 46,
            column: 34
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 46
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 10
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 27
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 62
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 7
          }
        },
        loc: {
          start: {
            line: 73,
            column: 12
          },
          end: {
            line: 73,
            column: 24
          }
        },
        line: 73
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        },
        loc: {
          start: {
            line: 77,
            column: 10
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 77
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 78,
            column: 26
          },
          end: {
            line: 78,
            column: 27
          }
        },
        loc: {
          start: {
            line: 78,
            column: 32
          },
          end: {
            line: 80,
            column: 5
          }
        },
        line: 78
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        loc: {
          start: {
            line: 83,
            column: 35
          },
          end: {
            line: 85,
            column: 3
          }
        },
        line: 83
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        loc: {
          start: {
            line: 87,
            column: 47
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 87
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 95,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        },
        loc: {
          start: {
            line: 95,
            column: 50
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 95
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        loc: {
          start: {
            line: 99,
            column: 11
          },
          end: {
            line: 112,
            column: 3
          }
        },
        line: 99
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 80
          }
        }, {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 80
          }
        }],
        line: 48
      },
      "1": {
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 48,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 48,
            column: 13
          }
        }, {
          start: {
            line: 48,
            column: 17
          },
          end: {
            line: 48,
            column: 44
          }
        }, {
          start: {
            line: 48,
            column: 48
          },
          end: {
            line: 48,
            column: 69
          }
        }],
        line: 48
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 11
          },
          end: {
            line: 49,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 49,
            column: 18
          },
          end: {
            line: 49,
            column: 29
          }
        }, {
          start: {
            line: 49,
            column: 32
          },
          end: {
            line: 49,
            column: 60
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 53,
            column: 35
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 53,
            column: 31
          },
          end: {
            line: 53,
            column: 35
          }
        }],
        line: 53
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 57,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 57,
            column: 7
          }
        }, {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 57,
            column: 7
          }
        }],
        line: 55
      },
      "6": {
        loc: {
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 55,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 55,
            column: 20
          }
        }, {
          start: {
            line: 55,
            column: 24
          },
          end: {
            line: 55,
            column: 41
          }
        }],
        line: 55
      },
      "7": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 52
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 52
          }
        }],
        line: 59
      },
      "8": {
        loc: {
          start: {
            line: 62,
            column: 13
          },
          end: {
            line: 62,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 62,
            column: 20
          },
          end: {
            line: 62,
            column: 25
          }
        }],
        line: 62
      },
      "9": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }],
        line: 63
      },
      "10": {
        loc: {
          start: {
            line: 102,
            column: 40
          },
          end: {
            line: 102,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 40
          },
          end: {
            line: 102,
            column: 46
          }
        }, {
          start: {
            line: 102,
            column: 50
          },
          end: {
            line: 102,
            column: 60
          }
        }],
        line: 102
      },
      "11": {
        loc: {
          start: {
            line: 106,
            column: 23
          },
          end: {
            line: 106,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 23
          },
          end: {
            line: 106,
            column: 28
          }
        }, {
          start: {
            line: 106,
            column: 32
          },
          end: {
            line: 106,
            column: 51
          }
        }],
        line: 106
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/Input.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { cascaderClass } from './styles';
import { focusElement, getCursorOffset, preventPasteFile } from '../utils/dom/element';
cov_42aiq0o6b.s[0]++;

var handleFocus = function handleFocus(e) {
  cov_42aiq0o6b.f[0]++;
  cov_42aiq0o6b.s[1]++;
  e.stopPropagation();
};

var FilterInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterInput, _Component);

  var _super = _createSuper2(FilterInput);

  function FilterInput(props) {
    var _this;

    _classCallCheck(this, FilterInput);

    cov_42aiq0o6b.f[1]++;
    cov_42aiq0o6b.s[2]++;
    _this = _super.call(this, props);
    _this.lastCursorOffset = void 0;
    _this.editElement = void 0;
    _this.blurTimer = void 0;
    cov_42aiq0o6b.s[3]++;
    _this.state = {
      editable: false
    };
    cov_42aiq0o6b.s[4]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_42aiq0o6b.s[5]++;
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_this));
    cov_42aiq0o6b.s[6]++;
    _this.handlePaste = _this.handlePaste.bind(_assertThisInitialized(_this));
    cov_42aiq0o6b.s[7]++;
    _this.focusInput = _this.focusInput.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_42aiq0o6b.f[2]++;
      cov_42aiq0o6b.s[8]++;
      this.focusInput(true);
    }
  }, {
    key: "getProcessedValue",
    value: function getProcessedValue(text) {
      cov_42aiq0o6b.f[3]++;

      var _ref = (cov_42aiq0o6b.s[9]++, this.props),
          trim = _ref.trim;

      cov_42aiq0o6b.s[10]++;

      if ((cov_42aiq0o6b.b[1][0]++, !trim) && (cov_42aiq0o6b.b[1][1]++, this.lastCursorOffset === 0) && (cov_42aiq0o6b.b[1][2]++, /^\u00A0$/.test(text))) {
        cov_42aiq0o6b.b[0][0]++;
        cov_42aiq0o6b.s[11]++;
        return '';
      } else {
        cov_42aiq0o6b.b[0][1]++;
      }

      cov_42aiq0o6b.s[12]++;
      return trim ? (cov_42aiq0o6b.b[2][0]++, text.trim()) : (cov_42aiq0o6b.b[2][1]++, text.replace(/\u00A0/g, ' '));
    }
  }, {
    key: "reset",
    value: function reset() {
      cov_42aiq0o6b.f[4]++;

      var _ref2 = (cov_42aiq0o6b.s[13]++, this.props),
          _ref2$emptyAfterSelec = _ref2.emptyAfterSelect,
          emptyAfterSelect = _ref2$emptyAfterSelec === void 0 ? (cov_42aiq0o6b.b[3][0]++, true) : _ref2$emptyAfterSelec,
          multiple = _ref2.multiple;

      cov_42aiq0o6b.s[14]++;

      if (this.editElement) {
        cov_42aiq0o6b.b[4][0]++;
        cov_42aiq0o6b.s[15]++;

        if (!((cov_42aiq0o6b.b[6][0]++, multiple) && (cov_42aiq0o6b.b[6][1]++, !emptyAfterSelect))) {
          cov_42aiq0o6b.b[5][0]++;
          cov_42aiq0o6b.s[16]++;
          this.editElement.innerText = '';
        } else {
          cov_42aiq0o6b.b[5][1]++;
        }
      } else {
        cov_42aiq0o6b.b[4][1]++;
      }

      cov_42aiq0o6b.s[17]++;

      if (this.blurTimer) {
        cov_42aiq0o6b.b[7][0]++;
        cov_42aiq0o6b.s[18]++;
        clearTimeout(this.blurTimer);
      } else {
        cov_42aiq0o6b.b[7][1]++;
      }
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      var _this2 = this;

      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_42aiq0o6b.b[8][0]++, false);
      cov_42aiq0o6b.f[5]++;
      cov_42aiq0o6b.s[19]++;

      if (!flag) {
        cov_42aiq0o6b.b[9][0]++;
        cov_42aiq0o6b.s[20]++;
        this.setState({
          editable: false
        });
        cov_42aiq0o6b.s[21]++;
        return;
      } else {
        cov_42aiq0o6b.b[9][1]++;
      }

      cov_42aiq0o6b.s[22]++;
      this.setState({
        editable: true
      }, function () {
        cov_42aiq0o6b.f[6]++;
        cov_42aiq0o6b.s[23]++;
        return _this2.focus();
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this3 = this;

      cov_42aiq0o6b.f[7]++;
      cov_42aiq0o6b.s[24]++;
      requestAnimationFrame(function () {
        cov_42aiq0o6b.f[8]++;
        cov_42aiq0o6b.s[25]++;
        focusElement.end(_this3.editElement);
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_42aiq0o6b.f[9]++;
      cov_42aiq0o6b.s[26]++;
      this.editElement = el;
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      cov_42aiq0o6b.f[10]++;
      var text = (cov_42aiq0o6b.s[27]++, e.target.innerText.replace('\feff ', ''));
      cov_42aiq0o6b.s[28]++;
      this.lastCursorOffset = getCursorOffset(text.length);
      var t = (cov_42aiq0o6b.s[29]++, this.getProcessedValue(text));
      cov_42aiq0o6b.s[30]++;
      this.props.onFilter(t);
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "handlePaste",
    value: function handlePaste(e) {
      cov_42aiq0o6b.f[11]++;
      cov_42aiq0o6b.s[31]++;
      preventPasteFile(e);
    }
  }, {
    key: "render",
    value: function render() {
      cov_42aiq0o6b.f[12]++;

      var _ref3 = (cov_42aiq0o6b.s[32]++, this.props),
          focus = _ref3.focus;

      var props = (cov_42aiq0o6b.s[33]++, {
        className: cascaderClass('input', (cov_42aiq0o6b.b[10][0]++, !focus) && (cov_42aiq0o6b.b[10][1]++, 'ellipsis')),
        ref: this.bindElement,
        key: 'input',
        onInput: this.handleInput,
        contentEditable: (cov_42aiq0o6b.b[11][0]++, focus) || (cov_42aiq0o6b.b[11][1]++, this.state.editable),
        onFocus: handleFocus,
        onPaste: this.handlePaste
      });
      cov_42aiq0o6b.s[34]++;
      return (
        /*#__PURE__*/
        React.createElement("span", Object.assign({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 111,
            columnNumber: 12
          }
        }))
      );
    }
  }]);

  return FilterInput;
}(Component);

export default FilterInput;